import {Injectable} from '@angular/core';
import {ApibaseService} from './apibase.service';
import {Observable, of} from 'rxjs';
import {catchError, map} from 'rxjs/operators';
import {
  ArquivoPedido,
  ArquivoRecibo, emptyArquivoRecibo,
  emptyDocumento,
  EntityDocumento,
} from '~entity/entity-documento/entity-documento.model';

@Injectable()
export class DocumentosService extends ApibaseService {

  prefixoUrl = 'controlTower';
  urlFunction = 'documentos';

  getDocumentosRota(id: string): Observable<EntityDocumento> {
    return super.get<ArquivoPedido[]>({extraUrl: this.mountUrl('rota', id)}).pipe(
      map(pedidos => ({id, arquivos: pedidos.filter(d => !d.nome.endsWith('.json'))})),
      this.defaultCatch(emptyDocumento())
    );
  }

  getRecibosRota(id: string): Observable<ArquivoRecibo[]> {
    return super.get<any[]>({extraUrl: this.mountUrl('rota/recibos', id)}).pipe(
      map(v => v.map(i => {
        const recibo = emptyArquivoRecibo(i);
        if (!recibo.links?.length && (i.linkView || i.linkDownload)) {
          recibo.links = [{
            linkView: i.linkView ?? '',
            linkDownload: i.linkDownload ?? '',
            name: i.name ?? '',
            createdIn: i.timestamp ?? Date.now(),
            format: 'IMAGEM' as const,
          }];
        }
        return recibo;
      })),
      this.defaultCatchList()
    );
  }

  downloadImage(url: string): Observable<Blob | null> {
    return this.http.get(url, {responseType: 'blob'}).pipe(
      catchError(err => of(err.status === 404 ? null : err))
    );
  }

  geraZipDocumentos(links: {pasta: string, link: string}[]): Observable<Blob | null> {
    const url = this.mountUrl(this.prefixoUrl, this.urlFunction, 'download');
    return this.http.post(url, links, {responseType: 'blob'}).pipe(
      catchError(err => of(err.status === 404 ? null : err))
    );
  }
}
